import { useEffect, useState } from "react"
import PlasticsApplication from "services/PlasticsApplication.service"
const STATIC_FILES = process.env.REACT_APP_STATIC_FILES

const user = JSON.parse(localStorage.getItem("authUser"))
const plasticsApp = new PlasticsApplication(user)

const ViewFiles = props => {
  const [attachments, setattachments] = useState([])
  const [isReturned, setisReturned] = useState()

  const download = (path, name) => {
    plasticsApp
      .downloadAttachment(path)
      .then(response => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]))
          const link = document.createElement("a")
          link.href = url
          link.setAttribute("download", name)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    // console.log("attachments -> ", props.attachments)
    let atts = []
    let kount = 0
    props.attachments.forEach(attach => {
      atts.push(
        <tr key={kount}>
          <td>{attach.description}</td>
          <td>{attach.file_name}</td>
          <td>
            <a href="#" onClick={e => download(attach.path, attach.file_name)}>
              <i
                className="fas fa-cloud-download-alt"
                title="Download"
                style={{ color: "green" }}
              ></i>
            </a>
          </td>
        </tr>
      )
      kount++
    })
    setattachments(atts)
  }, [props.attachments])

  useEffect(() => {
    setisReturned(props.isReturned)
  }, [props.isReturned])
  return (
    <div>
      <table className="table table-striped table-responsive">
        <thead>
          <th>Description</th>
          <th>Uploaded File</th>
          <th>Download</th>
        </thead>

        <tbody>{attachments}</tbody>
      </table>

      <div>
        {isReturned ? (
          <center>
            <a href="#" onClick={props.reupload} className="btn btn-info">
              Reupload Files
            </a>
          </center>
        ) : null}
      </div>
    </div>
  )
}

export default ViewFiles
